import { contractConstants } from "../../constants";

const defaultState = {
    items: [],
    item: {},
    loadingItems: false,
    loadingItem: false,
    fetchedItems: false,
    fetchedItem: false,
    error: null
};

function normalData(arr) {
    if (!Array.isArray(arr)) return []

    return arr.map((elem, index) => Object.assign(elem, { index: (index + 1) }))
}

export const typeReducer = function (state = defaultState, action) {
    switch (action.type) {
        case contractConstants.GETALL_REQUEST_TYPES:
            return {
                ...state,
                item: {},
                loadingItems: true,
                loadingItem: false,
                fetchedItems: false,
                fetchedItem: false,
                error: null
            };
        case contractConstants.GETALL_SUCCESS_TYPES:
            return {
                ...state,
                items: normalData(action.response),
                loadingItems: false,
                fetchedItems: true,
            };
        case contractConstants.GETALL_FAILURE_TYPES:
            return {
                ...state,
                loadingItems: false,
                fetchedItems: false,
                error: action.error,
            };

        case contractConstants.GETBYID_REQUEST_TYPES:
            return {
                ...state,
                item: {},
                loadingItem: true,
                fetchedItem: false,
                error: null
            };
        case contractConstants.GETBYID_SUCCESS_TYPES:
            return {
                ...state,
                item: action.response,
                loadingItem: false,
                fetchedItem: true,
            };
        case contractConstants.GETBYID_FAILURE_TYPES:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: false,
                error: action.error,
            };

        case contractConstants.CREATE_REQUEST_TYPES:
            return {
                ...state,
                item: {},
                loadingItem: true,
                fetchedItem: false,
                error: null
            };
        case contractConstants.CREATE_SUCCESS_TYPES:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: false,
                items: normalData(state.items.concat(action.response))
            };
        case contractConstants.CREATE_FAILURE_TYPES:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: false,
                error: action.error,
            };

        case contractConstants.UPDATE_REQUEST_TYPES:
            return {
                ...state,
                loadingItem: true,
                fetchedItem: false,
                error: null
            };
        case contractConstants.UPDATE_SUCCESS_TYPES:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: true,
                item: action.response,
                items: normalData(state.items.map((elem) => {
                    if (elem.id === action.response.id) return Object.assign(elem, { ...action.response })
                    return elem
                }))
            };
        case contractConstants.UPDATE_FAILURE_TYPES:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: false,
                error: action.error,
            };

        case contractConstants.ARCHIVE_REQUEST_TYPES:
            return {
                ...state,
                loadingItem: true,
                fetchedItem: false,
                error: null,
            };
        case contractConstants.ARCHIVE_SUCCESS_TYPES:
            return {
                ...state,
                loadingItem: false,
                fetchedItem: false,
                items: normalData(state.items.map((elem) => {
                    if (elem.id === action.id) return Object.assign(elem, { ...action.response, isArchive: !elem.isArchive })
                    return elem
                }))
            };
        case contractConstants.ARCHIVE_FAILURE_TYPES:
            return {
                ...state,
                loadingItem: false,
                error: action.error,
            };

        case contractConstants.DELETE_REQUEST_TYPES:
            return {
                ...state,
                item: {},
                loadingItems: true,
                loadingItem: false,
                fetchedItems: false,
                fetchedItem: false,
                error: null
            };
        case contractConstants.DELETE_SUCCESS_TYPES:
            return {
                ...state,
                loadingItems: false,
                fetchedItems: true,
                items: normalData(state.items.filter((elem) => elem.id !== action.id)),
            };
        case contractConstants.DELETE_FAILURE_TYPES:
            return {
                ...state,
                loadingItems: false,
                fetchedItems: false,
                error: action.error,
            };

        case "RESET_ITEM_TYPES":
            return {
                ...state,
                fetchedItem: false,
                loadingItem: false,
                item: {}
            }

        case "RESET_ITEMS_TYPES":
            return {
                ...state,
                fetchedItems: false,
                loadingItems: false,
                items: [],
                error: null
            }
        default:
            return state;
    }
}